import { Link } from "react-router";
import { ComparePage } from "./ComparePage";

// Angle: THROUGHPUT / AUTOMATION. The reader wants fewer hours per chart.
// Nothing here describes FrameworkRxP itself.
export function FrameworkrxpAlternative() {
  return (
    <ComparePage
      slug="frameworkrxp-alternative"
      competitor="FrameworkRxP"
      title="FrameworkRxP Alternative | WeConsult Rx"
      description="A FrameworkRxP alternative for chart-review automation: chart ingest, Beers/STOPP rules and AI-drafted rationale, prescriber and DON e-sign, and invoicing in one platform."
      h1="A FrameworkRxP alternative for chart-review automation."
      eyebrow="FrameworkRxP alternative"
      answer="Looking for a FrameworkRxP alternative? WeConsult Rx automates the repetitive parts of consultant chart review: it parses each month's EHR exports, runs codified rule packs on every resident, and drafts the recommendation rationale for the pharmacist to approve. Signed recommendations then flow to e-signature and invoicing without leaving the platform."
      criteriaHeading="Where chart-review time actually goes"
      criteriaLede="Automation only matters if it removes the hours you spend today. Measure each of these on a real facility."
      criteria={[
        { label: "Getting the chart in", detail: "Upload PDF or CSV exports once; residents and their medications are parsed instead of re-typed." },
        { label: "Screening every resident", detail: "Rule packs run on the whole census each month, so attention goes to residents with findings." },
        { label: "Writing the rationale", detail: "AI drafts each recommendation's clinical rationale with its criteria reference; you edit and approve." },
        { label: "Assembling the report", detail: "Recommendation bundles for prescribers and the DON are assembled from the approved items automatically." },
        { label: "Chasing signatures", detail: "Built-in e-signature and a facility portal replace fax-and-follow-up." },
        { label: "Billing the month", detail: "Invoices are generated from closed reviews and can sync to QuickBooks Online." },
      ]}
      sections={[
        {
          heading: "Measuring the difference",
          body: (
            <p>
              Time a pilot facility's month end to end, from export to invoice, rather than only the review screen.
              The <Link to="/roi-calculator">ROI calculator</Link> turns your facility and resident counts into an
              estimate, and the <Link to="/medication-regimen-review-software">MRR software page</Link> walks through
              each step.
            </p>
          ),
        },
      ]}
      faqs={[
        {
          q: "What is a good FrameworkRxP alternative for chart review automation?",
          a: "WeConsult Rx automates chart ingest, rule-based screening of every resident, and AI-drafted recommendation rationale, then carries approved recommendations to e-signature and invoicing in one platform.",
        },
        {
          q: "Does AI write the recommendations?",
          a: "AI drafts the rationale, but the consultant pharmacist reviews, edits, and approves every recommendation before anything reaches a prescriber.",
        },
        {
          q: "What file formats can I upload?",
          a: "The month's EHR exports as PDF or CSV, including PointClickCare reports.",
        },
      ]}
      related={[
        { to: "/medication-regimen-review-software", label: "MRR software", desc: "The monthly review, ingest to invoice." },
        { to: "/roi-calculator", label: "ROI calculator", desc: "Estimate hours saved per month." },
        { to: "/platform", label: "Platform overview", desc: "How the pieces fit together." },
      ]}
      cta={{
        title: "Time a month on WeConsult Rx",
        body: "Book a side-by-side demo on a sample facility, or start with a free first-facility review.",
      }}
    />
  );
}
